import gql from 'graphql-tag'

export default gql`mutation deleteUserExpense($id: Int!, $user_id: Int!, $is_paid: Int) {
    deleteUserExpense(id: $id, user_id: $user_id, is_paid: $is_paid) @client
}`